import React from "react";

import "./index.scss";

interface WorkTypeErrorMessageProps {
  /** Meta of the array-level `work_types` field. */
  meta: { isTouched: boolean; isBlurred: boolean; errors: unknown[] };
  /** The form had a submit attempt; a submit touches every mounted field. */
  submitAttempted: boolean;
}

const getMessage = (error: unknown): string | undefined => {
  if (typeof error === "string") return error;
  if (typeof error === "object" && error !== null && "message" in error && typeof error.message === "string") {
    return error.message;
  }
  return undefined;
};

/** Error of the whole `work_types` list (not of a single row); shown once the list was blurred, or the form had a submit attempt and the list is touched. */
const WorkTypeErrorMessage: React.FunctionComponent<WorkTypeErrorMessageProps> = ({ meta, submitAttempted }) => {
  const message = getMessage(meta.errors[0]);

  return (meta.isBlurred || (submitAttempted && meta.isTouched)) && message ? (
    <div className="work-type-error-message">{message}</div>
  ) : null;
};

export default WorkTypeErrorMessage;
